//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BiUserAccessService from '@/apps/data-platform/services/visualization/bi_user_access_service';
import tasks from '@/js/tasks';
export default {
  name: 'UserAccessDetails',
  props: {
    record: {
      type: Object,
      require: true,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      items: []
    };
  },
  computed: {
    fields: function fields() {
      return [{
        value: 'user_dp',
        text: this.traductor('my_tasks.tablas_tasks.user'),
        class: 'text-center w-20'
      }, {
        value: 'applicant_user',
        text: this.traductor('my_tasks.tablas_tasks.applicant'),
        class: 'text-center w-30',
        sortable: true
      }, {
        value: 'creation_date',
        text: this.traductor('my_tasks.tablas_tasks.creation_date'),
        class: 'text-center w-20',
        sortable: true
      }, {
        value: 'actions',
        text: this.traductor('my_tasks.tablas_tasks.actions'),
        class: 'text-center w-20'
      }];
    },
    texts: function texts() {
      return {
        deactivate: this.traductor('frases.deactivate'),
        delete: this.traductor('frases.delete'),
        delete_confirm: this.traductor('frases.delete_confirm'),
        activate: this.traductor('frases.activate')
      };
    }
  },
  created: function created() {
    this.getItems();
  },
  mounted: function mounted() {
    var _this = this;
    this.$bus.$on('onReloadDetail', function () {
      _this.getItems();
    });
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onClickActivate: function onClickActivate(item) {
      var _this2 = this;
      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var params = {
        record: {
          document_id: "".concat(item.user_dp, "_").concat(item.document_id),
          active: active
        }
      };
      BiUserAccessService.updateUserDP(params).then(function (response) {
        tasks.toast.success('Successful request!');
        //this.$toast.success('Successful request!')
        _this2.$set(item, 'active', active);
      });
    },
    onClickDelete: function onClickDelete(_index) {
      for (var index in this.items) {
        if (_index !== index) {
          this.$root.$emit('bv::hide::popover', "popover-button-sync-".concat(this.record.id).concat(index));
        }
      }
    },
    onDeleteClose: function onDeleteClose(index) {
      this.$root.$emit('bv::hide::popover', "popover-button-sync-".concat(this.record.id).concat(index));
    },
    onDeleteAccept: function onDeleteAccept(item, _index) {
      var _this3 = this;
      var params = {
        record: {
          document_id: "".concat(item.user_dp, "_").concat(item.document_id)
        }
      };
      BiUserAccessService.deleteUserDP(params).then(function (response) {
        if (response.data.success) {
          tasks.toast.success('Successful request!');
          //this.$toast.success('Successful request!')
          _this3.$root.$emit('bv::hide::popover', "popover-button-sync-".concat(_this3.record.id).concat(_index));
          _this3.items = _this3.items.filter(function (record, index) {
            return index !== _index;
          });
        }
      });
    },
    rowClass: function rowClass(item, type) {
      if (!item || type !== 'row') return;
      if (item.active) return 'table-success';
      if (!item.active) return 'table-danger';
    },
    getItems: function getItems() {
      var _this4 = this;
      var params = {
        record: {
          document_id: this.record.user_id
        }
      };
      BiUserAccessService.getUsersInca(params).then(function (response) {
        _this4.items = response.data.result;
      });
    }
  }
};